import { OLD_URLS } from "@/hooks/useURLSync/oldUtils";
import { ROUTES_CHILDREN_LOOKUP } from "@/routes/routes";
import type { RootState } from "@/store/store";
import { getFeatureRedirect } from "@/utils/featureStatus";
import { dequal } from "dequal";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

const NoMatch = () => {
  const [timeLeft, setTimeLeft] = useState(30);

  const featureStatus = useSelector(
    (state: RootState) => state.featureStatus,
    (prev, next) => dequal(prev, next)
  );

  const redirectBackToLogin = useCallback(() => {
    const redirectUrl = getFeatureRedirect(featureStatus as any);
    window.location.href = redirectUrl;
  }, []);

  useEffect(() => {
    if (timeLeft === 0) {
      redirectBackToLogin();
    }

    const timer = setTimeout(() => {
      if (timeLeft > 0) {
        setTimeLeft(timeLeft - 1);
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, [timeLeft, redirectBackToLogin]);

  if (
    OLD_URLS?.includes(location.pathname.toLowerCase()) ||
    Object.keys(ROUTES_CHILDREN_LOOKUP)?.includes(
      location.pathname?.toLowerCase()
    )
  ) {
    return null;
  }

  return (
    <div className="fixed z-[10000000] top-0 left-0 w-[100vw] h-[100vh] bg-[#f5f7fa] flex justify-center items-center">
      <div className="h-lvh flex-col flex justify-center items-center">
        <div className="w-[500px] bg-white p-[30px] border border-[#e4e7ec] bg-white">
          <div className="flex justify-center items-center ">
            <img
              className="w-[200px]"
              src="/images/logo/harris_questbrand_complete_logo.png"
              alt="Harris poll"
            />
          </div>
          <div className="my-[23px] border-y text-[#4A4A4A] border-[#e4e7ec] text-center tracking-[0.2px] [word-spacing:1.5px]">
            <div className="mt-[23px] mb-[18px] font-[16px] font-bold text-[23px]">
              404 - Page Not Found
            </div>
            <div>
              {/* {userType === "USER" */}
              The Page you are looking for does not exist
            </div>
            <div className="mb-[23px] mt-[16px]">
              Contact{" "}
              <a
                className="text-[#0000ee] underline"
                href="mailto:hbp@harrispoll.com"
              >
                hbp@harrispoll.com
              </a>{" "}
              for any further support.
            </div>
          </div>
          <div className="tracking-[0.2px] [word-spacing:1.5px]">
            <div className="text-base text-[#4A4A4A] text-center mt-[14px]">
              Redirecting in {timeLeft} seconds
            </div>
          </div>
        </div>
        <div className="text-xs text-[#4A4A4A] text-center mt-[14px]">
          <p>
            &#169; Harris Poll QuestBrand is Copyright of The Harris Poll 2024 -
            2025.
            <br />
            All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoMatch;
